"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const event_fragment_1 = __importDefault(require("../fragments/event.fragment"));
const query = (0, client_1.gql) `
  query eventsListOptimized($query: EventQueryInput, $pagination: PaginationInput) {
    events(query: $query, pagination: $pagination) {
      _id
      name
      subtitle
      cancel
      venueId
      type
      published
      tagIds
      description
      posterImageUrl {
        original
        medium
        small
      }
      venue {
        _id
        name
        address {
          city
          state
          timezone
        }
      }
       schedule {
        announceAt
        ticketsAt
        ticketsEndAt
        startsAt
        endsAt
      }
      performances {
        _id
        schedule {
          startsAt
          endsAt
          doorsAt
        }
      }
      ...TicketTypes
      analytics {
        segments {
          coordinates {
            x
            y
          }
        }
      }
    }
  }
     ${event_fragment_1.default.fragments.ticketTypes}
`;
exports.default = query;
//# sourceMappingURL=eventsListOptimized.query.js.map